<template>
    <div>
        <b-row>
            <b-col>
                <h3>Atendimentos</h3>
            </b-col>
        </b-row>
        <b-card>
            <b-row class="mt-2" align-v="end">
                <b-col>
                    <label for="">Atendimento</label>
                    <b-form-input size="sm" v-model="id" />
                </b-col>
                <b-col>
                    <label class="mb-0" for="">De</label>
                    <b-form-datepicker id="de" placeholder="Nenhuma Data" calendar-width="200" label-no-date-selected=""
                        label-next-month="Próximo Mês" label-next-year="Próximo Ano" label-prev-month="Mês Anterior"
                        label-prev-year="Ano Anterior" label-current-month="Mês Atual" label-help hide-header
                        reset-button reset-button-variant="danger" label-reset-button="Limpar" v-model="de" size="sm"
                        :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                        }" locale="pt-BR" />
                </b-col>
                <b-col>
                    <label class="mb-0" for="">Ate</label>
                    <b-form-datepicker id="ate" placeholder="Nenhuma Data" calendar-width="200"
                        label-no-date-selected="" label-next-month="Próximo Mês" label-next-year="Próximo Ano"
                        label-prev-month="Mês Anterior" label-prev-year="Ano Anterior" label-current-month="Mês Atual"
                        label-help hide-header reset-button reset-button-variant="danger" label-reset-button="Limpar"
                        v-model="ate" size="sm" :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                        }" locale="pt-BR" />
                </b-col>
                <b-col>
                    <label for="">Tipo</label>
                    <b-form-select :options="tipos" size="sm" v-model="tipo" />
                </b-col>
                <b-col>
                    <label for="">Status</label>
                    <b-form-select :options="listStatus" size="sm" v-model="status" />
                </b-col>
                <b-col>
                    <b-button size="sm" variant="primary" @click="getAtendimentos()">
                        <i class="fas fa-search"></i> Buscar
                    </b-button>
                </b-col>
                <b-col class="text-right" v-if="isDistribuidor">
                    <b-button size="sm" variant="success" @click="novoAtendimento()">
                        <i class="fas fa-plus"></i> Novo Atendimento
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="p-2" align-v="center">
                <b-col cols="8">
                    <b-pagination v-model="page" :total-rows="total" :per-page="perPage" align="fill" size="sm"
                        class="my-0" @input="getAtendimentos()"></b-pagination>
                </b-col>
                <b-col class="text-center">
                    <b-form-select class="md-1" v-model="perPage" :options="[5, 10, 20, 50, 100]" title="Por Página"
                        size="sm" @change="getAtendimentos()"></b-form-select>
                </b-col>
                <b-col class="text-right">
                    Total: {{ total }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col>
                    <b-table :items="atendimentos" :fields="getFields" :current-page="currentPage" :per-page="perPage"
                        hover :busy="loading" stacked="md" show-empty striped small
                        empty-text="Nenhum atendimento encontrado">
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Buscando...</strong>
                            </div>
                        </template>
                        <template #cell(actions)="row">
                            <b-button variant="primary" size="sm" @click="verAtendimento(row.item.id)" class="mr-1">
                                <i class="fas fa-comment"></i>
                            </b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
        <div>
            <v-atendimento :atendimento="atendimento" :sidebar="sidebar" :tipos="tipos"
                @close-sidebar="closeSidebar" @search_services="getAtendimentos"></v-atendimento>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            notificacoes: 0,
            page: 1,
            perPage: 5,
            total: 0,
            datePickerConfig: {
                'format': 'DD/MM/YYYY',
                'showClose': true,
                'useCurrent': false,
            },
            de: "",
            ate: "",
            id: "",
            tipo: "",
            tipos: [""],
            status: '',
            listStatus: ['', 'NOVO', 'ABERTO', 'FECHADO'],
            currentPage: 1,
            perPage: 10,
            total: 0,
            atendimentos: [],
            atendimento: {
                id: null,
                titulo: '',
                mensagens: []
            },
            sidebar: false,
            loading: false
        }
    },

    computed: {
        isDistribuidor() {
            return this.$store.getters['user/isDistribuidor'];
        },
        getFields() {
            if (this.isDistribuidor) {
                return [
                    { key: 'actions', label: '' },
                    { key: 'id', label: 'Código' },
                    { key: 'titulo', label: 'Título' },
                    { key: 'status', label: 'Status' },
                    {
                        key: 'created_at', label: 'Data',
                        formatter: (value) => {
                            return new Date(value).toLocaleString();
                        }
                    },
                    {
                        key: 'updated_at', label: 'Atualizado em',
                        formatter: (value) => {
                            return new Date(value).toLocaleString();
                        }
                    }
                ]
            } else {
                return [
                    { key: 'actions', label: '' },
                    { key: 'id', label: 'Código' },
                    {
                        key: 'distribuidor', label: 'Distribuidor',
                        formatter: (value, key, item) => {
                            return item.distribuidor.codigo + ' - ' + item.distribuidor.nome
                        }
                    },
                    { key: 'titulo', label: 'Título' },
                    { key: 'status', label: 'Status' },
                    { key: 'atendente', label: 'Atendente',
                    formatter: (value, key, item) => {
                            return item.atendente ? item.atendente.name : "";
                        }
                    },
                    {
                        key: 'created_at', label: 'Data',
                        formatter: (value) => {
                            return new Date(value).toLocaleString();
                        }
                    },
                    {
                        key: 'updated_at', label: 'Atualizado em',
                        formatter: (value) => {
                            return new Date(value).toLocaleString();
                        }
                    }
                ]
            }
        }
    },

    methods: {
        verAtendimento(id) {
            this.atendimento.id = id;
            this.sidebar = true;
        },
        novoAtendimento() {
            this.sidebar = true;
        },
        closeSidebar() {
            this.atendimento = {
                id: null,
                titulo: '',
                mensagens: [],
            }
            this.sidebar = false;
        },
        getAtendimentos() {
            const vm = this;
            this.loading = true
            const params = {
                page: this.currentPage,
                perPage: this.perPage,
                de: this.de,
                ate: this.ate,
                id: this.id,
                tipo: this.tipo,
                status: this.status,
                page: this.page
            }
            axios.get('/atendimentos/list', { params })
                .then(response => {
                    vm.total = response.data.total
                    vm.atendimentos = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                    vm.loading = false;
                });
        },
    },

    mounted() {
        const tipos = JSON.parse(document.getElementById('tipos-atendimento').value)
        this.tipos = tipos.map((el) => {
            return el.tipo
        })
        this.tipos.push("");
        this.getAtendimentos();
    }
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/atendimento/List.vue